const footLinks = [
  { label: "本期封面", href: "#covers" },
  { label: "话题墙", href: "#topics" },
  { label: "街拍更新", href: "#street" },
  { label: "同款穿搭", href: "#compare" },
  { label: "常见问题", href: "#faq" },
];

const channels = ["街拍照片", "机场照", "私服照", "素颜照", "同款穿搭", "生图对比"];

export default function Footer() {
  return (
    <footer className="border-t border-background-200/70 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2">
              <span className="grid h-9 w-9 place-items-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-camera-line text-xl" />
              </span>
              <span className="font-heading text-2xl font-bold tracking-tight text-foreground-950">
                吃瓜图集
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              吃瓜图集收罗街拍照片、机场照、私服照、素颜照与同款穿搭生图，
              路人视角直出对比看着更真实。街拍照片持续更新，想看真实状态来这就对了。
            </p>
            <div className="mt-5 flex items-center gap-2 text-foreground-400">
              {["ri-instagram-line", "ri-weibo-line", "ri-github-line", "ri-mail-line"].map((i) => (
                <a
                  key={i}
                  href="#top"
                  aria-label="社交入口"
                  className="grid h-9 w-9 cursor-pointer place-items-center rounded-md border border-background-200 bg-background-50 transition-colors hover:text-primary-600 hover:border-primary-300"
                >
                  <i className={`${i} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-widest2 text-foreground-400">
              快速导航
            </p>
            <ul className="mt-4 space-y-2.5">
              {footLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs font-semibold uppercase tracking-widest2 text-foreground-400">
              栏目分类
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {channels.map((c) => (
                <span
                  key={c}
                  className="cursor-pointer rounded-full bg-background-50 px-3.5 py-1.5 text-xs text-foreground-600 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
                >
                  {c}
                </span>
              ))}
            </div>
            <p className="mt-6 text-sm leading-relaxed text-foreground-600">
              每日早 7:00 更新 · 只看状态，不追八卦
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-400 sm:flex-row">
          <span>© {new Date().getFullYear()} 吃瓜图集 · 街拍私服合集</span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-arrow-up-line" /> 页面内容仅供穿搭参考
          </span>
        </div>
      </div>
    </footer>
  );
}